import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

import ManagementSearch from "../../../components/pages/Management/ManagementSearch/ManagementSearch";
import { ButtonWrapper } from "../../Settings/AccountDetails/AccountDetails.styled";
import { useSelector } from "../../../redux/hooks";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useRestricted from "../../../components/pages/Management/useRestricted";

const mapClients = (data: any) => {
  // let list: IClient[] = [];
  // if (data?.data?.content?.list) {
  //   list = data.data.content.list.map((el: IClient) => ({
  //     ...el,
  //     active: el.active,
  //   }));
  // }
  return { ...data?.data?.content, list: data?.data?.content?.list ?? [] };
};

const Clients = () => {
  const { clientAdmin, isRestrictedToYacht, isRestrictedToOrg } = useSelector(
    state => state.permsSlice,
  );
  useRestricted([clientAdmin, isRestrictedToYacht, isRestrictedToOrg]);

  const { data, isLoading, refetch } = useGetApi({
    request: "get-management",
    body: { _sect: "_clients" },
    mapper: mapClients,
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper>
          <ManagementSearch
            section={"_clients"}
            refetch={refetch}
            currentRequestParams={{ _sect: "_clients" }}
          />
        </ButtonWrapper>
      </Breadcrumbs>
      <ManagementTable
        section="_clients"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Clients;
